import {
    AnimationBaseController,
    GameRandom,
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { GameLogic } from "../../../Logic/GameLogic";
import { DbLightController } from "./DbLightController";
import { OutfitInnerLightController } from "./OutfitInnerLightController";

export interface IOutfitInnerControllerOptions {
}

export class OutfitInnerController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IOutfitInnerControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("OutfitInnerController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            childControllers: {
                /*Light: {
                    controller: OutfitInnerLightController,
                    model: this.$model,
                    instanceName: 'outfit_glow'
                }*/
            },
        };
    }

    protected onInitialize(): void {

    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
}

